const React = require("react");
const moment = require("moment");
const navigator = require("~/navigator.js");

require("./SurveyStatusEntry.less");

const MetaAuditType = require("~/types/MetaAudit.js").PropType;
const auditCreationDispatchers = require("~/events/auditCreation/auditCreationDispatchers.js");

const SurveyStatusEntry = React.createClass({
    propTypes: {
        MetaAudit: MetaAuditType.isRequired
    },
    render() {
        const audit = this.props.MetaAudit;
                        
        if (audit.Status === "Complete") {
            const ref =
                audit.IsLegacy
                ? "#" + navigator.GetLink.ToLegacySurvey(audit.AuditType, audit.FacilityNumber, audit.PKID)
                : "#" + navigator.GetLink.ToSummary(audit.AuditType, audit.FacilityNumber, audit.PKID);
            
            return (<div className="cs-SurveyStatusEntry">
                <div className="cs-SurveyStatusEntry__line-1">
                    <div className="cs-SurveyStatusEntry__mark--complete">
                        COMPLETE
                    </div>
                    <div className="cs-SurveyStatusEntry__type">
                        {audit.FriendlyTypeName}
                    </div>
                    <div className="cs-SurveyStatusEntry__period">
                        {audit.AuditPeriod}
                    </div>
                    <div className="cs-SurveyStatusEntry__actions">
                        <a className="cs-SurveyStatusList__ListItem__link" href={ref}>
                            View Summary
                        </a>
                    </div>
                </div>
                <div className="cs-SurveyStatusEntry__line-2">
                    <div className="cs-SurveyStatusEntry__mark">
                        &nbsp;
                    </div>
                    <div className="cs-SurveyStatusEntry__remark">
                        Completed by&nbsp;
                        {audit.CompletedBy},&nbsp;
                        {moment(audit.Completed).format("MM-DD-YYYY")}
                    </div>
                    <div className="cs-SurveyStatusEntry__score">
                        Score&nbsp;{audit.Score}/{audit.MaxScore}
                    </div>
                </div>
            </div>);
        }

        if (audit.Status === "In progress") {
            const ref = `#survey/${audit.AuditType}/${audit.FacilityNumber}/${audit.PKID}`;

            return (<div className="cs-SurveyStatusEntry">
                <div className="cs-SurveyStatusEntry__line-1">
                    <div className="cs-SurveyStatusEntry__mark--in-progress">
                        IN PROGRESS
                    </div>
                    <div className="cs-SurveyStatusEntry__type">
                        {audit.FriendlyTypeName}
                    </div>
                    <div className="cs-SurveyStatusEntry__period">
                        {audit.AuditPeriod}
                    </div>
                    <div className="cs-SurveyStatusEntry__actions">
                        <a className="cs-SurveyStatusList__ListItem__link" href={ref}>
                            Continue Audit
                        </a>
                    </div>
                </div>
                <div className="cs-SurveyStatusEntry__line-2">
                    <div className="cs-SurveyStatusEntry__mark">
                        &nbsp;
                    </div>
                    <div className="cs-SurveyStatusEntry__remark">
                        Created by&nbsp;
                        {audit.CreatedBy}&nbsp;
                        {moment(audit.Created).format("MM-DD-YYYY")}
                    </div>
                    <div className="cs-SurveyStatusEntry__score">
                        &nbsp;
                    </div>
                </div>
            </div>);
        }

        const create = () => {
            auditCreationDispatchers.Create(audit.AuditType, audit.FacilityNumber, audit.AuditPeriod);
        };

        return (<div className="cs-SurveyStatusEntry">
            <div className="cs-SurveyStatusEntry__line-1">
                <div className="cs-SurveyStatusEntry__mark--not-started">
                    Not started
                </div>
                <div className="cs-SurveyStatusEntry__type">
                    {audit.FriendlyTypeName}
                </div>
                <div className="cs-SurveyStatusEntry__period">
                    {audit.AuditPeriod}
                </div>
                <div className="cs-SurveyStatusEntry__actions">
                </div>
            </div>
        </div>);
    }
});

module.exports = SurveyStatusEntry;


// WEBPACK FOOTER //
// ./src/components/SurveyStatusEntry/SurveyStatusEntry.jsx